import styled from 'styled-components';
var Wrapper = styled.div.withConfig({
  componentId: "sc-1dozp4c-0"
})(["position:relative;width:100%;display:block;"]);
var ArrowWrapper = styled.div.withConfig({
  componentId: "sc-1dozp4c-1"
})(["position:absolute;top:0;bottom:0;display:none;flex-direction:column;justify-content:space-around;visibility:hidden;opacity:0;transition:opacity 0.25s ease,visibility 0s linear 0.25s;pointer-events:none;&.showing{display:flex;transition:opacity 0.25s ease,visibility 0s linear;pointer-events:auto;visibility:visible;opacity:1;}", ""], function (_ref) {
  var direction = _ref.direction,
      arrowPosition = _ref.arrowPosition;
  var oppositeDirection = direction === "left" ? "right" : "left";
  return "\n        " + direction + ": " + (arrowPosition === "inside" ? "30px" : "0px") + ";\n        width: 0;\n        & > button {\n            " + oppositeDirection + ": 0;\n            transform: translateX(-50%);        \n        }\n    ";
});
var CarouselSlideInner = styled.div.withConfig({
  componentId: "sc-1dozp4c-2"
})(["", " height:100%;"], function (_ref2) {
  var theme = _ref2.theme,
      offset = _ref2.offset;
  return offset && "transform: translateX(" + theme.spacing(offset) + ");";
});
var CarouselSlide = styled.div.withConfig({
  componentId: "sc-1dozp4c-3"
})(["flex:1 0;", " &:last-child{margin-right:0;}"], function (_ref3) {
  var slidesPerPage = _ref3.slidesPerPage,
      gutter = _ref3.gutter,
      offset = _ref3.offset,
      theme = _ref3.theme;
  var offsetString = typeof offset === "undefined" ? "" : " + " + theme.spacing(offset);
  var size = "calc((100% / " + slidesPerPage + ") - ((" + theme.spacing(gutter) + " * " + (slidesPerPage - 1) + ")" + offsetString + ") / " + slidesPerPage + ")";
  return "\n            min-width: " + size + "; \n            max-width: " + size + "; \n            margin-right: " + theme.spacing(gutter) + ";";
});
var ScrollContainer = styled.div.withConfig({
  componentId: "sc-1dozp4c-4"
})(["overflow:hidden;overflow-x:scroll;-webkit-overflow-scrolling:touch;position:relative;display:flex;white-space:nowrap;scrollbar-width:none;font-size:0;line-height:1;-ms-overflow-style:none;&::-webkit-scrollbar{width:0;height:0;display:none;}", ""], function (_ref4) {
  var offset = _ref4.offset,
      theme = _ref4.theme;
  return typeof offset !== "undefined" ? "\n        padding-right: " + theme.spacing(offset) + ";\n        &:after {\n            content: ' ';\n            min-width: calc(2 * " + theme.spacing(offset) + ");\n        }" : "";
});
var Styled = {
  Wrapper: Wrapper,
  ArrowWrapper: ArrowWrapper,
  CarouselSlideInner: CarouselSlideInner,
  CarouselSlide: CarouselSlide,
  ScrollContainer: ScrollContainer
};
export { Styled };